import { useCallback } from 'react';
import dayjs from 'dayjs';

import { DATETIME_DOTS_FORMAT } from '@/common/constants';
import downloadFileByUrl from '@/utils/handlers/downloadFileByUrl';

const useDownloadCSV = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleDownload = useCallback((data: any, format: 'csv' | 'pdf', fileName?: string) => {
    const currentDate = dayjs(Date.now()).format(DATETIME_DOTS_FORMAT);
    const fileExtension = format;
    const currentFileName = `${fileName || ''}_${currentDate}.${fileExtension}`;
    const blob = new Blob([data], { type: `text/${format}` });
    const url = window.URL.createObjectURL(blob);
    downloadFileByUrl([url], currentFileName);
  }, []);
  return handleDownload;
};

export default useDownloadCSV;
